import { Link, Stack, Tabs, RelativePathString } from 'expo-router';
import React from 'react';
import { Platform, Pressable, StyleSheet, View } from 'react-native';
import { CustomTextStyles } from '@/components/CustomText';
import { useColorScheme } from '@/components/useColorScheme';
import Colors from '@/constants/Colors';
import { Image } from 'expo-image';
import { Button } from 'react95-native-rabbl';
import { createBottomTabNavigator, BottomTabBarProps, BottomTabBarButtonProps } from "expo-router/js-tabs";
import { useLinkBuilder, useTheme } from "expo-router/react-navigation";
import * as AppUtils from '@/utilities/AppUtils';
import * as AppUtilities from '@/utilities/AppUtilities';
import { ExternalLink } from '@/components/ExternalLink';
import DrawerButton from '@/components/DrawerButton';
import { AppText } from '@/components/AppText';
import { HeaderLeft } from '@/components/HeaderLeft';
import { WidthResponsiveText } from '@/components/WidthResponsiveText';

const styles = StyleSheet.create({
  image28x28: {
    width: 28,
    height: 28,
  },
  headerIcon: {
    width: 28,
    height: 28,
    marginLeft: 15,
    marginRight: 10,
  },
  tabButtonsContainerStyle: {
    flexDirection: 'row',
    gap: 5,
    justifyContent: 'center',
    padding: 5,
  },
  tabButtonContainerStyle: {
    width: 75,
  },
});

export default function TabLayout() {
  return (
    <Stack
      screenOptions={{
        // Remove horizontal bottom line for header
        headerShadowVisible: false,

        headerStyle: {
          backgroundColor: 'transparent',
        },

        headerBackTitle: '',

        headerBackButtonDisplayMode: 'minimal',
                
        headerTitle: ({ children }) => (
          <WidthResponsiveText leftPadding={50} rightPadding={50} style={CustomTextStyles.headerTitle}>
            {children}
          </WidthResponsiveText>
        ),

        headerLeft: () => <HeaderLeft />,

        headerRight: () => <DrawerButton />,
      }}
    >
      <Stack.Screen name="index" options={{ title: 'Rabbl' }} />
      <Stack.Screen name="login" options={{ title: 'Login' }} />
    </Stack>
  );
}
